import { on } from '@ember/modifier';
import { or } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import GhostButton from 'ember-simplepractice/components/spds/action/button/ghost';
import styles from './draft-conversation-banner.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

<template>
  <aside class={{styles.component}} data-test-draft-conversation-banner>
    <header class="banner-header">
      <h2 class="banner-title" data-test-draft-conversation-banner-title>
        {{t "emc.draft_conversation_banner.title"}}
      </h2>
      <p class="banner-description" data-test-draft-conversation-banner-description>
        {{t "emc.draft_conversation_banner.description"}}
      </p>
    </header>

    {{#if (or @showNameConversationAction @showModifyMembersAction @showViewProfileAction)}}
      <footer class="banner-actions" data-test-draft-conversation-banner-actions>
        {{#if @showNameConversationAction}}
          <GhostButton
            @size="small"
            class="banner-action"
            {{on "click" @onNameConversation}}
            data-test-draft-conversation-banner-name
          >
            {{svgJar "messaging-pen-write" class="banner-action-icon"}}
            {{#if @hasDisplayName}}
              {{t "emc.draft_conversation_banner.rename_conversation"}}
            {{else}}
              {{t "emc.draft_conversation_banner.name_conversation"}}
            {{/if}}
          </GhostButton>
        {{/if}}

        {{#if @showModifyMembersAction}}
          <GhostButton
            @size="small"
            class="banner-action"
            {{on "click" @onModifyMembers}}
            data-test-draft-conversation-banner-modify-members
          >
            {{svgJar "messaging-users" class="banner-action-icon"}}
            {{t "emc.draft_conversation_banner.modify_members"}}
          </GhostButton>
        {{/if}}

        {{#if @showViewProfileAction}}
          <GhostButton
            @size="small"
            class="banner-action"
            {{on "click" @onViewProfile}}
            data-test-draft-conversation-banner-view-profile
          >
            {{svgJar "messaging-user" class="banner-action-icon"}}
            {{t "emc.draft_conversation_banner.view_profile"}}
          </GhostButton>
        {{/if}}
      </footer>
    {{/if}}
  </aside>
</template>
